<template lang="html">
  <app-modal @close="close" class="alert">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get(`Alert`)}}
      </template>
      <template v-slot:content>
        <div class="content">
          <p class="text" v-html>
            {{ text }}
          </p>
          <app-btn @click="close">{{$ml.get(`Okay`)}}</app-btn>
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {

  },
  methods: {
    close() {
      this.$store.commit('modals/alert/close');
    }
  },
  computed: {
    ...mapGetters({
      text: 'modals/alert/text',
    })
  },
}
</script>

<style lang="scss" scoped>

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;

  .text {
    padding-bottom: 20px;
    margin: 0;
    line-height: 1.2;
    white-space: pre-line;
  }
}

</style>
